import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column align-items-center my-5"
}
const _hoisted_5 = {
  class: "d-none",
  "data-user-role": ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Bereich wechseln", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Für deine Benutzergruppe steht der Verwaltungsbereich bereit:")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { href: "https://verwaltung.buggyfit.betastatus.de" }, "Zur Verwaltung wechseln", -1)
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = {
  key: 2,
  class: "d-flex flex-column align-items-center my-5"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Anmeldung erforderlich", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Du wirst weitergeleitet... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.userRole > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(JSON.stringify(_ctx.userRole, null, 2)), 1),
          _createVNode(_component_Alert, { type: "warning" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performLogout && _ctx.performLogout(...args)), ["prevent"]))
            }, "Abmelden")
          ])
        ]))
      : (_ctx.authFailed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_Alert, { type: "danger" }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                _hoisted_17
              ]),
              _: 1
            })
          ]))
        : (_ctx.loggedIn)
          ? _renderSlot(_ctx.$slots, "default", { key: 3 })
          : _createCommentVNode("", true)
}